/* BOONZY · Squish Theory runtime. No dependencies. */
(() => {
  const d = document;
  const root = d.documentElement;
  root.classList.add('bz-js');
  const BZ = (window.BZ = window.BZ || {});
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Money ---------- */
  BZ.money = (cents) => {
    const fmt = BZ.moneyFormat || '${{amount}}';
    const n = (Number(cents) || 0) / 100;
    const withSep = (v, dec, ts, ds) => {
      const [i, f] = v.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (f ? ds + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withSep(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withSep(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withSep(n, 0, '.', ',');
      return withSep(n, 2, ',', '.');
    });
  };

  /* ---------- Observers: reveal, play-once icons, lazy videos ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const el = e.target;
      if (el.hasAttribute('data-reveal') && e.isIntersecting) {
        el.classList.add('is-in');
        io.unobserve(el);
      }
      if (el.hasAttribute('data-bz-play') && e.isIntersecting && !reduce) {
        el.classList.add('is-play');
        setTimeout(() => el.classList.remove('is-play'), 1700);
        io.unobserve(el);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

  const vio = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) {
        if (v.dataset.src && !v.src) { v.src = v.dataset.src; }
        if (!reduce) v.play().catch(() => {});
      } else if (!v.paused) v.pause();
    });
  }, { rootMargin: '120px' });

  BZ.scan = (scope = d) => {
    $$('[data-reveal]', scope).forEach((el) => {
      if (!el.style.getPropertyValue('--i')) {
        const sibs = Array.from(el.parentElement.children).filter((c) => c.hasAttribute('data-reveal'));
        el.style.setProperty('--i', Math.min(sibs.indexOf(el), 6));
      }
      io.observe(el);
    });
    $$('[data-bz-play]', scope).forEach((el) => io.observe(el));
    $$('video[data-bz-video]', scope).forEach((v) => { v.muted = true; v.playsInline = true; vio.observe(v); });
  };

  /* ---------- Header: hide on scroll down, show on scroll up ---------- */
  const header = $('.bz-header');
  if (header) {
    let last = scrollY;
    addEventListener('scroll', () => {
      const y = scrollY;
      const open = d.body.classList.contains('bz-locked');
      header.classList.toggle('is-hidden', !open && y > 260 && y > last + 4);
      if (y < last - 4 || y < 260) header.classList.remove('is-hidden');
      last = y;
    }, { passive: true });
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  BZ.open = (id) => {
    const dr = d.getElementById(id);
    if (!dr) return;
    lastFocus = d.activeElement;
    dr.classList.add('is-open');
    dr.setAttribute('aria-hidden', 'false');
    d.body.classList.add('bz-locked');
    d.body.style.overflow = 'hidden';
    setTimeout(() => { const f = $('[data-bz-close], button, a, input', dr.querySelector('.bz-drawer__panel')); f && f.focus(); }, 60);
  };
  BZ.close = (dr) => {
    dr = dr || $('.bz-drawer.is-open');
    if (!dr) return;
    dr.classList.remove('is-open');
    dr.setAttribute('aria-hidden', 'true');
    d.body.classList.remove('bz-locked');
    d.body.style.overflow = '';
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  d.addEventListener('click', (e) => {
    const o = e.target.closest('[data-bz-open]');
    if (o) { e.preventDefault(); BZ.open(o.dataset.bzOpen); return; }
    const c = e.target.closest('[data-bz-close]');
    if (c) { e.preventDefault(); BZ.close(c.closest('.bz-drawer')); }
  });
  d.addEventListener('keydown', (e) => { if (e.key === 'Escape') BZ.close(); });

  /* ---------- Cart (AJAX + Section Rendering API) ---------- */
  const cartSection = 'bz-cart-drawer';
  const setCount = (n) => $$('[data-bz-count]').forEach((el) => {
    el.textContent = n; el.dataset.count = n;
    el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
  });
  const swapCart = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-bz-cart-inner]');
    const cur = $('[data-bz-cart-inner]');
    if (fresh && cur) { cur.replaceWith(fresh); BZ.scan(fresh); }
  };
  BZ.refreshCart = async () => {
    const r = await fetch(`${BZ.routes.root}?sections=${cartSection}`);
    const j = await r.json();
    swapCart(j[cartSection]);
    const c = await (await fetch(`${BZ.routes.cart}.js`)).json();
    setCount(c.item_count);
  };
  BZ.add = async (items, opts = {}) => {
    const r = await fetch(`${BZ.routes.cart_add}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: cartSection, sections_url: location.pathname })
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
    if (opts.checkout) { location.href = BZ.discount ? `/checkout?discount=${encodeURIComponent(BZ.discount)}` : '/checkout'; return j; }
    if (j.sections) swapCart(j.sections[cartSection]);
    const c = await (await fetch(`${BZ.routes.cart}.js`)).json();
    setCount(c.item_count);
    if ($('#bz-cart')) BZ.open('bz-cart'); else location.href = BZ.routes.cart;
    return j;
  };
  const change = async (line, quantity) => {
    const inner = $('[data-bz-cart-inner]');
    inner && inner.classList.add('is-busy');
    const r = await fetch(`${BZ.routes.cart_change}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: cartSection, sections_url: location.pathname })
    });
    const j = await r.json();
    if (j.sections) swapCart(j.sections[cartSection]);
    setCount(j.item_count || 0);
  };
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-bz-qty]');
    if (!b) return;
    e.preventDefault();
    const line = Number(b.dataset.line);
    const input = b.closest('.bz-qty') && $('input', b.closest('.bz-qty'));
    const cur = input ? Number(input.value) : 0;
    const next = b.dataset.bzQty === 'remove' ? 0 : Math.max(0, cur + Number(b.dataset.bzQty));
    if ($('[data-bz-cart-inner]')) change(line, next);
  });
  let noteT;
  d.addEventListener('input', (e) => {
    if (!e.target.matches('[data-bz-note]')) return;
    clearTimeout(noteT);
    noteT = setTimeout(() => fetch(`${BZ.routes.cart_update}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: e.target.value })
    }), 500);
  });

  /* ---------- Hero portals: pair physics follow the pointer ---------- */
  $$('[data-bz-portals]').forEach((wrap) => {
    if (reduce || matchMedia('(hover: none)').matches) return;
    const ps = $$('.bz-portal', wrap);
    wrap.closest('section').addEventListener('pointermove', (e) => {
      const r = wrap.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width - 0.5;
      const y = (e.clientY - r.top) / r.height - 0.5;
      ps.forEach((p, i) => {
        const k = i ? -18 : 14;
        p.style.setProperty('--px', `${(x * k).toFixed(1)}px`);
        p.style.setProperty('--py', `${(y * k).toFixed(1)}px`);
      });
    });
  });

  /* ---------- Press to squish ---------- */
  const lines = (BZ.squishLines || []).filter(Boolean);
  const pops = ['squish!', 'boing', 'oof', 'mmm', 'soft.', 'again?'];
  $$('[data-bz-squish]').forEach((stage) => {
    const num = $('[data-bz-squish-count]', stage.closest('section') || d);
    const msg = $('[data-bz-squish-msg]', stage.closest('section') || d);
    let n = Number(store.get('bz-squish')) || 0;
    if (num) num.textContent = n;
    const press = (e) => {
      stage.classList.add('is-press');
      if (e && e.pointerType && stage.setPointerCapture) { try { stage.setPointerCapture(e.pointerId); } catch (_) {} }
    };
    const release = (e) => {
      if (!stage.classList.contains('is-press')) return;
      stage.classList.remove('is-press');
      n += 1;
      store.set('bz-squish', n);
      BZ.squished && BZ.squished();
      if (num) { num.textContent = n; num.classList.remove('is-bump'); void num.offsetWidth; num.classList.add('is-bump'); }
      if (msg && lines.length) {
        const steps = [1, 3, 7, 12, 20, 35, 50, 75, 100];
        const idx = steps.filter((s) => n >= s).length - 1;
        if (idx >= 0 && lines[Math.min(idx, lines.length - 1)]) msg.textContent = lines[Math.min(idx, lines.length - 1)];
      }
      const r = stage.getBoundingClientRect();
      const p = d.createElement('span');
      p.className = 'bz-squish__pop';
      p.textContent = pops[n % pops.length];
      const cx = e && e.clientX ? e.clientX - r.left : r.width / 2;
      const cy = e && e.clientY ? e.clientY - r.top : r.height / 2;
      p.style.left = `${cx}px`; p.style.top = `${cy - 20}px`;
      p.style.setProperty('--r', `${(Math.random() * 24 - 12).toFixed(0)}deg`);
      stage.appendChild(p);
      setTimeout(() => p.remove(), 1000);
    };
    stage.addEventListener('pointerdown', press);
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', () => stage.classList.remove('is-press'));
    stage.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') release(e); });
    stage.addEventListener('keydown', (e) => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); press(); } });
    stage.addEventListener('keyup', (e) => { if (e.key === ' ' || e.key === 'Enter') release(); });
  });

  /* ---------- Reel: drag to scroll + arrows ---------- */
  $$('[data-bz-rail]').forEach((rail) => {
    let down = false, sx = 0, sl = 0, moved = 0;
    rail.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = 0; sx = e.clientX; sl = rail.scrollLeft; });
    addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx));
      if (moved > 6) rail.classList.add('is-drag');
      rail.scrollLeft = sl - dx;
    });
    addEventListener('pointerup', () => { down = false; setTimeout(() => rail.classList.remove('is-drag'), 0); });
    const sec = rail.closest('section');
    $$('[data-bz-rail-go]', sec).forEach((b) => b.addEventListener('click', () => {
      const card = rail.firstElementChild;
      const step = card ? card.getBoundingClientRect().width + 22 : 300;
      rail.scrollBy({ left: step * Number(b.dataset.bzRailGo), behavior: reduce ? 'auto' : 'smooth' });
    }));
  });

  /* ---------- Night sky ---------- */
  $$('[data-bz-stars]').forEach((sky) => {
    const n = Number(sky.dataset.bzStars) || 60;
    let html = '';
    for (let i = 0; i < n; i++) {
      const s = (Math.random() * 2.4 + 1.2).toFixed(1);
      html += `<i style="left:${(Math.random() * 100).toFixed(2)}%;top:${(Math.random() * 100).toFixed(2)}%;width:${s}px;height:${s}px;animation-delay:${(Math.random() * -4).toFixed(2)}s;animation-duration:${(Math.random() * 3 + 2.5).toFixed(1)}s"></i>`;
    }
    sky.innerHTML = html;
  });

  /* ---------- Anatomy: spots ↔ notes ---------- */
  $$('[data-bz-anat]').forEach((sec) => {
    const spots = $$('.bz-spot', sec), notes = $$('.bz-note', sec);
    const on = (i) => {
      sec.classList.toggle('has-focus', i > -1);
      spots.forEach((s, k) => s.classList.toggle('is-on', k === i));
      notes.forEach((s, k) => s.classList.toggle('is-on', k === i));
    };
    [...spots, ...notes].forEach((el) => {
      const i = Number(el.dataset.i);
      el.addEventListener('mouseenter', () => on(i));
      el.addEventListener('mouseleave', () => on(-1));
      el.addEventListener('focus', () => on(i));
      el.addEventListener('blur', () => on(-1));
      el.addEventListener('click', () => on(sec.querySelector('.bz-spot.is-on') === spots[i] ? -1 : i));
    });
  });

  /* ---------- Reaction bingo ---------- */
  $$('[data-bz-bingo]').forEach((sec) => {
    const cells = $$('.bz-cell', sec);
    const status = $('.bz-bingo__status', sec);
    const lines = [];
    for (let i = 0; i < 5; i++) {
      lines.push([0, 1, 2, 3, 4].map((k) => i * 5 + k));
      lines.push([0, 1, 2, 3, 4].map((k) => k * 5 + i));
    }
    lines.push([0, 6, 12, 18, 24], [4, 8, 12, 16, 20]);
    const on = (i) => cells[i].classList.contains('is-on') || cells[i].classList.contains('bz-cell--free');
    cells.forEach((c) => {
      if (c.classList.contains('bz-cell--free')) return;
      c.addEventListener('click', () => {
        c.classList.toggle('is-on');
        c.setAttribute('aria-pressed', c.classList.contains('is-on'));
        const count = cells.filter((x) => x.classList.contains('is-on')).length;
        const win = lines.some((l) => l.every(on));
        status.classList.toggle('is-win', win);
        status.textContent = win ? sec.dataset.win : count ? sec.dataset.progress.replace('[n]', count) : sec.dataset.idle;
      });
    });
  });

  /* ---------- Product form ---------- */
  $$('[data-bz-product]').forEach((form) => {
    const sec = form.closest('[data-bz-pdp]') || d;
    const data = JSON.parse($('[data-bz-variants]', sec).textContent);
    const idInput = $('input[name="id"]', form);
    const btn = $('[data-bz-atc]', form);
    const btnLabel = $('[data-bz-atc-label]', form);
    const btnPrice = $('[data-bz-atc-price]', form);
    const tiers = $$('.bz-tier', form);
    let variant = data.find((v) => String(v.id) === idInput.value) || data[0];

    const tierQty = () => { const t = tiers.find((x) => x.classList.contains('is-on')); return t ? Number(t.dataset.qty) : 1; };
    // same rounding as Shopify's automatic % discount: per-unit discount rounded down
    const unitAfter = (p, dc) => p - Math.floor(p * dc / 100);
    // a tier either has a fixed bundle price (cents) or a % discount
    const tierTotal = (t) => {
      if (!t) return variant.price;
      const q = Number(t.dataset.qty);
      return t.dataset.fixed ? Number(t.dataset.fixed) : unitAfter(variant.price, Number(t.dataset.discount)) * q;
    };

    const paint = () => {
      const q = tierQty();
      const total = tierTotal(tiers.find((x) => x.classList.contains('is-on')));
      const was = Math.max(variant.compare_at_price || 0, variant.price) * q;
      $$('[data-bz-price]', sec).forEach((el) => { el.textContent = BZ.money(variant.price); });
      $$('[data-bz-compare]', sec).forEach((el) => {
        el.textContent = variant.compare_at_price > variant.price ? BZ.money(variant.compare_at_price) : '';
      });
      $$('[data-bz-save]', sec).forEach((el) => {
        const pct = variant.compare_at_price > variant.price ? Math.round((1 - variant.price / variant.compare_at_price) * 100) : 0;
        el.hidden = !pct; el.textContent = el.dataset.tpl.replace('[pct]', pct);
      });
      tiers.forEach((t) => {
        const tq = Number(t.dataset.qty);
        const now = tierTotal(t);
        const tw = Math.max(variant.compare_at_price || 0, variant.price) * tq;
        $('[data-tier-now]', t).textContent = BZ.money(now);
        const s = $('[data-tier-was]', t); if (s) s.textContent = tw > now ? BZ.money(tw) : '';
      });
      if (btnPrice) btnPrice.textContent = BZ.money(total);
      $$('[data-bz-sticky-price]').forEach((el) => { el.textContent = BZ.money(total) + (was > total ? ` · ${el.dataset.saveLabel || 'save'} ${BZ.money(was - total)}` : ''); });
      const ok = variant.available;
      btn.disabled = !ok;
      $$('[data-bz-sticky-atc]').forEach((b) => { b.disabled = !ok; });
      if (btnLabel) btnLabel.textContent = ok ? btnLabel.dataset.add : btnLabel.dataset.sold;
      idInput.value = variant.id;
      $$('[data-bz-opt-value]', sec).forEach((el) => { el.textContent = variant.options[Number(el.dataset.bzOptValue)] || ''; });
    };

    $$('input[data-bz-option]', form).forEach((inp) => inp.addEventListener('change', () => {
      const chosen = $$('input[data-bz-option]:checked', form).map((i) => i.value);
      const match = data.find((v) => v.options.every((o, k) => o === chosen[k]));
      if (match) {
        variant = match;
        if (match.featured_media_id) BZ.galleryTo && BZ.galleryTo(sec, match.featured_media_id);
        if (history.replaceState) {
          const u = new URL(location.href); u.searchParams.set('variant', match.id); history.replaceState({}, '', u);
        }
      }
      paint();
    }));
    tiers.forEach((t) => {
      const r = $('input', t);
      r.addEventListener('change', () => { tiers.forEach((x) => x.classList.toggle('is-on', x === t)); paint(); });
    });
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      btn.classList.add('is-loading');
      const props = {};
      const gift = $('[data-bz-giftnote]', form);
      if (gift && gift.value.trim()) props[gift.dataset.label || 'Gift note'] = gift.value.trim();
      try {
        await BZ.add([{ id: Number(variant.id), quantity: tierQty(), properties: props }], { checkout: form.dataset.bzMode === 'checkout' });
      } catch (err) {
        const er = $('[data-bz-error]', form);
        if (er) { er.hidden = false; er.textContent = err.message; }
      } finally { btn.classList.remove('is-loading'); }
    });
    $$('[data-bz-sticky-atc]').forEach((b) => b.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : btn.click()));

    const sticky = $('[data-bz-sticky]');
    if (sticky) {
      new IntersectionObserver(([e]) => {
        sticky.classList.toggle('is-on', !e.isIntersecting && (e.boundingClientRect.top < 0 || scrollY > 120));
      }).observe(btn);
      // shown whenever the main button is off screen (above or below), once the visitor starts scrolling
      addEventListener('scroll', () => {
        const r = btn.getBoundingClientRect();
        sticky.classList.toggle('is-on', (r.bottom < 0 || r.top > innerHeight) && scrollY > 120);
      }, { passive: true });
    }
    paint();
  });

  /* ---------- Gallery ---------- */
  $$('[data-bz-gallery]').forEach((gal) => {
    const slides = $$('.bz-gal__slide', gal);
    const thumbs = $$('.bz-thumb', gal);
    const main = $('.bz-gal__main', gal);
    const hint = $('.bz-gal__hint', gal);
    let cur = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    const go = (i) => {
      cur = (i + slides.length) % slides.length;
      slides.forEach((s, k) => {
        const on = k === cur;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', !on);
        const v = $('video', s);
        if (v) { if (on) { v.muted = true; v.play().catch(() => {}); } else v.pause(); }
      });
      thumbs.forEach((t, k) => { t.classList.toggle('is-active', k === cur); t.setAttribute('aria-current', k === cur); });
      if (hint) hint.style.opacity = slides[cur].classList.contains('bz-gal__slide--product') ? '1' : '0';
      const t = thumbs[cur]; t && t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
    };
    BZ.galleryTo = (scope, mediaId) => {
      const idx = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (idx > -1) go(idx);
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    $$('[data-bz-gal-go]', gal).forEach((b) => b.addEventListener('click', () => go(cur + Number(b.dataset.bzGalGo))));
    // swipe
    let sx = null;
    main.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      if (sx === null) return;
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 45) go(cur + (dx < 0 ? 1 : -1));
      sx = null;
    });
    // press to squish (product shots only)
    main.addEventListener('pointerdown', () => { if (slides[cur].classList.contains('bz-gal__slide--product')) main.classList.add('is-press'); });
    main.addEventListener('pointerup', () => { if (main.classList.contains('is-press')) BZ.squished && BZ.squished(); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach((ev) => main.addEventListener(ev, () => main.classList.remove('is-press')));
    go(cur);
  });

  /* ---------- Squish reward: after a random 5–15 squishes, offer the pair (once per visit) ---------- */
  const reward = $('[data-bz-reward]');
  if (reward) {
    const sget = (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
    const sset = (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} };
    const min = Number(reward.dataset.min) || 5;
    const max = Math.max(min, Number(reward.dataset.max) || 15);
    let goal = Number(sget('bz-rw-goal'));
    if (!goal) { goal = min + Math.floor(Math.random() * (max - min + 1)); sset('bz-rw-goal', goal); }
    let count = Number(sget('bz-rw-count')) || 0;
    const sticky = $('[data-bz-sticky]');
    const scrim = $('[data-bz-reward-scrim]');
    const show = () => {
      reward.hidden = false;
      if (scrim) scrim.hidden = false;
      requestAnimationFrame(() => { reward.classList.add('is-on'); scrim && scrim.classList.add('is-on'); });
      sticky && sticky.classList.add('is-muted');
      sset('bz-rw-seen', '1');
      const c = $('[data-bz-reward-count]', reward); if (c) c.textContent = count;
      const mp = $('[data-bz-atc-price]'), rp = $('[data-bz-reward-price]', reward);
      if (mp && rp) rp.textContent = mp.textContent;
      setTimeout(() => { const b = $('[data-bz-reward-go]', reward); b && b.focus({ preventScroll: true }); }, 450);
    };
    const hide = () => {
      reward.classList.remove('is-on');
      scrim && scrim.classList.remove('is-on');
      sticky && sticky.classList.remove('is-muted');
      setTimeout(() => { reward.hidden = true; if (scrim) scrim.hidden = true; }, 500);
    };
    BZ.squished = () => {
      count += 1;
      sset('bz-rw-count', count);
      if (count >= goal && !sget('bz-rw-seen')) setTimeout(show, 650);
    };
    $$('[data-bz-reward-close]', reward).forEach((b) => b.addEventListener('click', hide));
    scrim && scrim.addEventListener('click', hide);
    d.addEventListener('keydown', (e) => { if (e.key === 'Escape' && reward.classList.contains('is-on')) hide(); });
    const go = $('[data-bz-reward-go]', reward);
    go && go.addEventListener('click', (e) => {
      if (reward.dataset.code) BZ.discount = reward.dataset.code;
      const form = $('[data-bz-product]');
      if (form) {            // product page: buy what is selected (bundle, colour, gift note)
        e.preventDefault();
        go.classList.add('is-loading');
        form.requestSubmit ? form.requestSubmit() : $('[data-bz-atc]', form).click();
      }                      // elsewhere the link is a cart permalink straight to checkout
    });
  }

  /* ---------- Honest countdown: real daily cutoff or real sale end, never a fake reset ---------- */
  $$('[data-bz-timer]').forEach((el) => {
    const tz = el.dataset.tz || 'America/New_York';
    const txt = $('[data-bz-timer-txt]', el);
    // wall-clock parts of "now" in the shop's time zone
    const partsIn = (date) => {
      const p = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', weekday: 'short' })
        .formatToParts(date).reduce((o, x) => (o[x.type] = x.value, o), {});
      return { y: +p.year, mo: +p.month, d: +p.day, h: +p.hour, mi: +p.minute, s: +p.second, wd: p.weekday };
    };
    // epoch ms of a wall-clock time in tz
    const zoned = (y, mo, d, h, mi) => {
      const guess = Date.UTC(y, mo - 1, d, h, mi);
      const p = partsIn(new Date(guess));
      const asUtc = Date.UTC(p.y, p.mo - 1, p.d, p.h, p.mi, p.s);
      return guess - (asUtc - guess);
    };
    const target = () => {
      if (el.dataset.mode === 'deadline') {
        const m = (el.dataset.deadline || '').match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
        if (!m) return null;
        return { at: zoned(+m[1], +m[2], +m[3], +(m[4] || 23), +(m[5] || 59)), day: '' };
      }
      const cut = Number(el.dataset.cutoff) || 14;
      const now = new Date();
      const p = partsIn(now);
      for (let i = 0; i < 8; i++) {
        const base = new Date(Date.UTC(p.y, p.mo - 1, p.d + i, 12));
        const wd = base.getUTCDay();
        if (wd === 0 || wd === 6) continue;
        const at = zoned(base.getUTCFullYear(), base.getUTCMonth() + 1, base.getUTCDate(), cut, 0);
        if (at > now.getTime()) {
          const day = i === 0 ? el.dataset.today : i === 1 ? el.dataset.tomorrow : base.toLocaleDateString('en-US', { weekday: 'long', timeZone: 'UTC' });
          return { at, day };
        }
      }
      return null;
    };
    let t = target();
    if (!t) return;
    const pad = (n) => String(n).padStart(2, '0');
    const unit = (v, u, cls) => `<b class="bz-timer__u ${cls}"><i>${pad(v)}</i>${u}</b>`;
    const tick = () => {
      let ms = t.at - Date.now();
      if (ms <= 0) {
        if (el.dataset.mode === 'deadline') { el.hidden = true; clearInterval(iv); return; }
        t = target(); if (!t) { el.hidden = true; return; } ms = t.at - Date.now();
      }
      const s = Math.floor(ms / 1000);
      const dd = Math.floor(s / 86400), hh = Math.floor((s % 86400) / 3600), mm = Math.floor((s % 3600) / 60), ss = s % 60;
      const timer = `<span class="bz-timer__clock">${dd ? unit(dd, 'd', '') : ''}${unit(hh, 'h', '')}${unit(mm, 'm', '')}${unit(ss, 's', 'is-sec')}</span>`;
      txt.innerHTML = el.dataset.tpl.replace('[timer]', timer).replace('[day]', `<b>${t.day}</b>`);
      el.hidden = false;
    };
    tick();
    const iv = setInterval(tick, 1000);
  });

  /* ---------- Honest delivery estimate (business days, weekends skipped) ---------- */
  $$('[data-bz-eta]').forEach((el) => {
    const add = (n) => {
      const dt = new Date();
      let left = n;
      while (left > 0) { dt.setDate(dt.getDate() + 1); if (dt.getDay() % 6 !== 0) left -= 1; }
      return dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    };
    $('span', el).innerHTML = el.dataset.tpl
      .replace('[from]', `<b>${add(Number(el.dataset.min) || 8)}</b>`)
      .replace('[to]', `<b>${add(Number(el.dataset.max) || 15)}</b>`);
  });

  BZ.scan();
})();
